export const GET_CONFIGURATION_MODELS_REQUESTED =
  'GET_CONFIGURATION_MODELS_REQUESTED'
export const GET_CONFIGURATION_MODELS_SUCCEEDED =
  'GET_CONFIGURATION_MODELS_SUCCEEDED'
export const GET_CONFIGURATION_MODELS_FAILED =
  'GET_CONFIGURATION_MODELS_FAILED'
